/**
 * @fileoverview DELETE handler for the "/alloys/gemini/agentic/:app_group_id/oauth/disconnect" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteAlloysGeminiAgenticOauthDisconnectCacheKeys } from "./constants";
import type {
  DeleteAlloysGeminiAgenticOauthDisconnectProps,
  DeleteAlloysGeminiAgenticOauthDisconnectResult,
} from "./types";

export const deleteAlloysGeminiAgenticAppGroupIdOauthDisconnect = reactQueryMutationAdapter(
  deleteAlloysGeminiAgenticOauthDisconnectCacheKeys,
  (
    props: DeleteAlloysGeminiAgenticOauthDisconnectProps
  ): Promise<DeleteAlloysGeminiAgenticOauthDisconnectResult> => {
    return fetch(`/alloys/gemini/agentic/${props.appGroupId}/oauth/disconnect`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
